import mitt from 'mitt';
import { btnTd } from '@/api/typing';
import defaultSlotList from '@/components/page-model/slotList';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import { message, Modal } from 'ant-design-vue';
import { query_person_to_costom_list, send_receipt } from '@/api/mjstore-model';
import { delete_c_z_record } from '@/api/mjstore-model';
import bus from '@/utils/bus';
const event_bus = bus;
export const event_obj = mitt();
export const btn_list = [
  // {
  //   name: '发送',
  //   clazz: 'primary',
  //   content: (record: any) => {
  //     return record.receipt_confirmed ? '已确认' : '发送';
  //   },
  //   disabled: (record: any) => {
  //     return !!record.receipt_confirmed;
  //   },
  //   cb: (record: any) => {
  //     const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
  //     query_person_to_costom_list({
  //       org_id: current_org?.id,
  //       customer_id: record.customer_id,
  //     }).then((res: any) => {
  //       if (res.data.length == 0 || (res.data.length > 0 && !res.data[0].name)) {
  //         Modal.warning({
  //           title: '提示',
  //           content: '会员尚未绑定，无法发送',
  //         });
  //       } else {
  //         const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
  //         Modal.confirm({
  //           title: '提示',
  //           content: `即将发送充值记录至客户公众号账号，是否继续发送（第${
  //             record.receipt_count + 1
  //           }次发送）`,
  //           onOk() {
  //             send_receipt({
  //               obj_id: record.id,
  //               business_type: 'CZRecord',
  //               org_id: current_org?.id,
  //             }).then(res => {
  //               message.success('发送成功');
  //               Object.assign(record, res);
  //             });
  //           },
  //           onCancel() {},
  //         });
  //       }
  //     });
  //   },
  // },
  {
    name: '作废',
    //type: 'dropdown',
    clazz: 'danger',
    is_show: (record: any) => {
      return record.is_active;
    },
    cb: (record: any) => {
      Modal.confirm({
        title: '提示',
        content: `是否作废此项记录`,
        onOk() {
          const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
          delete_c_z_record({
            czrecord_id: record.id,
            org_id: current_org?.id,
          }).then(() => {
            message.success('作废成功');
            event_obj.emit('refresh');
            event_bus.emit('refresh_custom_info', record.customer_id);
          });
        },
        onCancel() {},
      });
    },
  },
];
export const slotList = defaultSlotList;
export const config = {
  creatCol: [6, 6],
  updateCol: [6, 6],
};

export const head_btn_list = [];
